var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#32A840",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 24.4203H21.4C22.05 24.4203 22.59 23.8403 22.59 23.1403C22.59 22.2703 22.28 22.1003 21.77 21.9203L20.76 21.5703V24.4203H20.75Z",
    fill: "#32A840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9699 10.4004C14.4499 10.4204 9.97994 14.9104 9.99994 20.4304C10.0199 25.9504 14.5099 30.4204 20.0299 30.4004C25.5499 30.3804 30.0199 25.8904 29.9999 20.3704C29.9799 14.8504 25.4899 10.3904 19.9699 10.4004ZM22.2599 20.5004C23.0399 20.7704 24.0899 21.3504 24.0899 23.1404C24.0899 24.6804 22.8799 25.9204 21.3999 25.9204H20.7499V26.5004C20.7499 26.9104 20.4099 27.2504 19.9999 27.2504C19.5899 27.2504 19.2499 26.9104 19.2499 26.5004V25.9204H18.8899C17.2499 25.9204 15.9199 24.5404 15.9199 22.8404C15.9199 22.4304 16.2599 22.0904 16.6699 22.0904C17.0799 22.0904 17.4199 22.4304 17.4199 22.8404C17.4199 23.7104 18.0799 24.4204 18.8899 24.4204H19.2499V21.0404L17.7399 20.5004C16.9599 20.2304 15.9099 19.6504 15.9099 17.8604C15.9099 16.3204 17.1199 15.0804 18.5999 15.0804H19.2499V14.5004C19.2499 14.0904 19.5899 13.7504 19.9999 13.7504C20.4099 13.7504 20.7499 14.0904 20.7499 14.5004V15.0804H21.1099C22.7499 15.0804 24.0799 16.4604 24.0799 18.1604C24.0799 18.5704 23.7399 18.9104 23.3299 18.9104C22.9199 18.9104 22.5799 18.5704 22.5799 18.1604C22.5799 17.2904 21.9199 16.5804 21.1099 16.5804H20.7499V19.9604L22.2599 20.5004Z",
    fill: "#32A840"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.42 17.8701C17.42 18.7401 17.73 18.9101 18.24 19.0901L19.25 19.4401V16.5801H18.6C17.95 16.5801 17.42 17.1601 17.42 17.8701Z",
    fill: "#32A840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.0777e38f771454c69f838029a0856933.svg";
export { ForwardRef as ReactComponent };